// extracted by mini-css-extract-plugin
export default {"container":"TitleComponent_container__FKdkv","child":"TitleComponent_child__EfWSu"};